import { render } from "./VariableSelection.vue?vue&type=template&id=9c207832&scoped=true&ts=true"
import script from "./VariableSelection.vue?vue&type=script&lang=ts"
export * from "./VariableSelection.vue?vue&type=script&lang=ts"

import "./VariableSelection.vue?vue&type=style&index=0&id=9c207832&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c207832"]])

export default __exports__